// The shared Checkbox disables the ripple, which also removes its keyboard
// focus indicator.
export const SX_CHECKBOX_FOCUS_VISIBLE = {
  "&.Mui-focusVisible": {
    outline: "2px solid",
    outlineColor: "primary.main",
    outlineOffset: "1px",
    borderRadius: "50%",
  },
};
